import { Paper, Typography, Stack } from "@mui/material"
import { Disbursement } from "api"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import EditTable from "v2/EditTable"
import AddDisbursement from "./AddDisbursement"
import CreateDisbursement from "./CreateDisbursement"
import { Edit } from "@mui/icons-material"
import LabelValue from "../LabelValue"
import SimpleTable from "v2/SimpleTable"


const statistics = [
    {
        name: "repay_percent",
        label: "Repay Percent"
    },
    {
        name: "total_disbursement",
        label: "Total Disbursement"
    },
    {
        name: "repayment_received",
        label: "Repayment Received"
    },
    {
        name: "outstanding_disbursment",
        label: "Outstanding Disbursement"
    },
    {
        name: "pending_repayment",
        label: "Pending Repayment"
    },
    {
        name: "purpose",
        label: "Purpose"
    },
    {
        name: "disbursement_schedule",
        label: "Disbursement Schedule"
    },
    {
        name: "request_amt",
        label: "Request Amount"
    },
    {
        name: "approved_amt",
        label: "Approved Amount"
    },
    {
        name: "grant_type",
        label: "Grant Type"
    },
    {
        name: "disbursement_count",
        label: "Disbursement Count"
    }
]

const disburseColumns = [
    {
        label: "ID",
        name: "id"
    },
    {
        label: "Planed Amount",
        name: "installment_amt",
    },
    {
        label: "Planed Date",
        name: "planned_date",
    },
    {
        label: "Actual Amount",
        name: "disbursed_amt",
    },
    {
        label: "Acutal Date",
        name: "disbursed_date",
    },
    {
        label: "Description",
        name: "disbursement_txn_info",
    },
    {
        label: "Status",
        name: "disbursement_status",
    },
    {
        name: "action",
        label: "Action"
    }
]


const staCol = [
    {
        label: "Name",
        name: "name"
    },
    {
        label: "Value",
        name: "value"
    }
]

const DisbursementView = () => {

    const [data, setData] = useState({})
    const [payload, setPayload] = useState(null)
    const { id: case_id } = useParams()

    const getData = async () => {
        try {
            const res = await Disbursement.getMany({ params: { case_id } })
            setData(res)
        } catch (error) {
            alert(error.message)
        }
    }

    useEffect(() => {
        getData()
    }, [])

    const onClose = res => {
        if (res) {
            res = res.pop()
            const f = data.disbursement_details.map(d => {
                if (d.id == res.id) {
                    return { ...d, ...res }
                }
                return d
            })
            setData({ ...data, disbursement_details: f })
        }
        setPayload(null)
    }

    const onAdd = res => {
        if (res) {
            getData()
        }
    }

    const { disbursement_details = [] } = data
    const rows = disbursement_details.map(d => {
        const id = <a onClick={() => setPayload(d)} style={{ color: "blue", cursor: "pointer" }} className='a'>#{d.id}</a>
        const action = <span className="edit-btn" onClick={() => setPayload(d)}><Edit /></span>
        return { ...d, id, action }
    })

    const staRow = statistics.map(d => {
        const name = d.label
        const value = data[d.name]
        return { name, value }
    })


    return <Paper elevation={3}>
        <AddDisbursement payload={payload} onClose={onClose} />
        <Typography color={'primary'} padding={2} flex={1} variant='h5'>Disbursement statistics</Typography>
        {/* <LabelValue data={data} schema={statistics} /> */}
        <SimpleTable columns={staCol} data={staRow} />
        <br />
        <Stack flexDirection={"row"} padding={2}>
            <Typography flex={1} variant='h5'>Disbursements</Typography>
            <CreateDisbursement data={data} onChange={onAdd} />
        </Stack>
        <EditTable columns={disburseColumns} data={rows} />
    </Paper>
}

export default DisbursementView